import moment from 'moment-timezone'

/**
 * Check if the application is running in a mobile device
 *
 * @returns true or false
 */
export function isMobile() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true
  } else {
    return false
  }
}

/**
 * Remove special characters of a string
 *
 * @param {String} text
 * @returns
 */
export function strNormalize(text, lowerCase, charsToRemove) {
  if (text == undefined || text == null || text == '') {
    return ''
  }

  if (!isNaN(text)) {
    text = Object.prototype.toString.call(text)
  }

  var specialChars = new Array(
    'á',
    'à',
    'â',
    'ã',
    'ä',
    'é',
    'è',
    'ê',
    'ë',
    'í',
    'ì',
    'î',
    'ï',
    'ó',
    'ò',
    'ô',
    'õ',
    'ö',
    'ú',
    'ù',
    'û',
    'ü',
    'ç',
    'Á',
    'À',
    'Â',
    'Ã',
    'Ä',
    'É',
    'È',
    'Ê',
    'Ë',
    'Í',
    'Ì',
    'Î',
    'Ï',
    'Ó',
    'Ò',
    'Ô',
    'Õ',
    'Ö',
    'Ú',
    'Ù',
    'Û',
    'Ü',
    'Ç'
  )

  var normalChars = new Array(
    'a',
    'a',
    'a',
    'a',
    'a',
    'e',
    'e',
    'e',
    'e',
    'i',
    'i',
    'i',
    'i',
    'o',
    'o',
    'o',
    'o',
    'o',
    'u',
    'u',
    'u',
    'u',
    'c',
    'A',
    'A',
    'A',
    'A',
    'A',
    'E',
    'E',
    'E',
    'E',
    'I',
    'I',
    'I',
    'I',
    'O',
    'O',
    'O',
    'O',
    'O',
    'U',
    'U',
    'U',
    'U',
    'C'
  )

  for (let char in specialChars) {
    text = text.replaceAll(specialChars[char], normalChars[char])
  }

  if (charsToRemove != undefined) {
    for (let char in charsToRemove) {
      text = text.replaceAll(charsToRemove[char], '')
    }
  }

  if (lowerCase != undefined) {
    text = text.toLowerCase()
  }

  return text.trim()
}

export function calculateStorageSize(storage, verbose) {
  if (!storage) {
    storage = sessionStorage
  }
  var _lsTotal = 0,
    _xLen,
    _x,
    _t
  for (_x in storage) {
    if (verbose) {
      console.log('..', _x)
    }
    try {
      let tmp = JSON.parse(storage.getItem(_x))
      for (_t in tmp) {
        _xLen = (tmp[_t].toString().length + _t.length) * 2
        if (verbose) {
          console.log(
            ' ....' +
              _t.substr(0, 50) +
              ' = ' +
              (_xLen / 1024).toFixed(2) +
              ' KB'
          )
        }
      }
    } catch (err) {
      let tmp = storage.getItem(_x)
      _xLen = (tmp.toString().length + _x.length) * 2
    }
    if (!storage.hasOwnProperty(_x)) {
      continue
    }
    _xLen = (storage[_x].length + _x.length) * 2
    _lsTotal += _xLen
    if (verbose) {
      console.log(' ....SUBTOTAL' + ' = ' + (_xLen / 1024).toFixed(2) + ' KB')
    }
  }
  if (verbose) {
    console.log(
      'Storage Total = ' +
        (_lsTotal / 1024).toFixed(2) +
        'KB (' +
        (_lsTotal / (1024 * 1204)).toFixed(2) +
        'MB)'
    )
  }
  return {
    totalB: _lsTotal.toFixed(2),
    totalKB: (_lsTotal / 1024).toFixed(2),
    totalMB: (_lsTotal / (1024 * 1204)).toFixed(2),
  }
}

export function printReportPropertiesSortedBySize() {
  const vuexData = localStorage.getItem('vuex')

  if (!vuexData) {
    console.log('Não há dados do Vuex armazenados no localStorage.')
    return
  }

  const vuexObject = JSON.parse(vuexData)
  const reportData = vuexObject.report

  if (!reportData) {
    console.log(
      "Não há dados de relatório na propriedade 'report' do objeto Vuex."
    )
    return
  }

  // Converter o objeto de relatorio em um array de propriedades
  const reportProperties = Object.entries(reportData)

  // Ordenar as propriedades por tamanho ocupado em megabyte
  reportProperties.sort(([keyA, valueA], [keyB, valueB]) => {
    const sizeA = new Blob([JSON.stringify(valueA)]).size / (1024 * 1024)
    const sizeB = new Blob([JSON.stringify(valueB)]).size / (1024 * 1024)
    return sizeB - sizeA
  })

  // Imprimir as propriedades ordenadas
  reportProperties.forEach(([key, value]) => {
    console.log(
      `Propriedade: ${key}, Tamanho: ${(
        new Blob([JSON.stringify(value)]).size /
        (1024 * 1024)
      ).toFixed(2)} MB`
    )
  })
}

export function formatDate(date, format, tz) {
  //TODO: ajustar para receber timezone dinamicamente do usuário
  return moment
    .tz(date, tz || 'America/Bahia')
    .format(format || 'DD/MM/YYYY, HH[h]mm')
}
export default {}
